<template>
  <div class="content main-container">
    <div class="tips">
      <img src="@/static/images/contentManage/tips.png" alt="">
      <div class="tipsContent">
        <span class="tips1">本模块支持您自己创建海报，也支持您从公共素材库导入需要的素材。</span>
        <div class="tips2">
          <i class="iconfont iconzhuyi1"></i>
          <span>本功能需配套使用APP端
            <span style="color: #FF0000;">新版</span>【<img src="@/static/images/contentManage/new2.png" alt="">
            展业素材】，如果您有此类自定义的需求，请在展业端配置-模块配置里将对应
            <span style="color: #FF0000;">旧版</span>【展业素材】删除，添加
            <span style="color: #FF0000;">新版</span>
            系统工具：【<img src="@/static/images/contentManage/new2.png" alt="">展业素材】</span>
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">海报名称</span>
        <Input v-model="searchParams.title" placeholder="模糊搜索" clearable />
      </div>
      <div class="input-item">
        <span class="label">关联产品</span>
        <Select :label-in-value="true" v-model="searchParams.productCodeList" placeholder="请选择" filterable clearable multiple>
          <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{
            product.productName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">展示机构</span>
        <selectTree type="4" status="1" v-model="searchParams.orgId"></selectTree>
      </div>
      <div class="input-item">
        <span class="label">来源</span>
        <RadioGroup v-model="searchParams.source" @on-change="getPoster()">
          <Radio label="">全部</Radio>
          <Radio label="0">素材库</Radio>
          <Radio label="1">自建</Radio>
        </RadioGroup>
      </div>
      <div class="input-item">
        <span class="label">创建时间</span>
        <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom" format="yyyy-MM-dd"
          placeholder="选择日期" :value="searchParams.date" @on-change="searchParams.date = $event"></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" ghost @click="reset()">重置</Button>
      </div>
    </div>
    <div class="buttonBox">
      <Button type="primary" @click="$refs.posterModal.open()" v-if="$units.pointAction('content_2_1_1')">+新增</Button>
      <Button type="warning" @click="toPublicMaterialsPage" v-if="$units.pointAction('content_2_1_4')">从公共素材库导入</Button>
    </div>
    <div class="tabBtn">
      <Tabs v-model="activeTab" @on-click="changeTab">
        <TabPane :label="item.name + '(' + item.nums + ')'" :name="item.id" v-for="(item, i) in posterArr" :key="i">
        </TabPane>
      </Tabs>
      <div class="btn">
        <span @click="addType()" v-if="$units.pointAction('content_2_1_2')">新增分类</span>
        <span @click="manageType()" v-if="$units.pointAction('content_2_1_2')">管理分类</span>
      </div>
    </div>
    <!-- 批量操作栏 -->
    <div class="batchOperation" v-if="tableData.length > 0">
      <div class="checkBoxList">
        <Checkbox class="checkBox" :disabled="isAll" v-model="isOnePage" @on-change="handleCheck">当前页海报</Checkbox>
        <Checkbox class="checkBox" v-model="isAll" @on-change="handleCheckAll">全部海报</Checkbox>
        <div class="quantity">
          已选择 <span style="color: #236dff">{{ isAll ? total : checkItemsList.length }}</span> 项
        </div>
      </div>
      <div>
        <Button type="primary" ghost @click="openVisibleChange" v-if="$units.pointAction('content_2_1_1')">移动分类</Button>
        <Button type="primary" ghost style="margin-right:20px;" @click="batchDelete" v-if="$units.pointAction('content_2_1_3')">批量删除</Button>
      </div>
    </div>
    <loading :isShow="listLoading" />
    <no-data v-if="tableData.length == 0"></no-data>
    <div class="contentList" v-else>
      <div 
        v-for="(item, index) in tableData" 
        :key="index" 
        class="posterList" 
        @mouseleave="control = false" 
        @click.stop="!isAll && selectedItem(item)"
      >
        <div class="poster">
          <img :src="item.url" :preview="_uid" :ref="'img' + index" :class="checkAllGroup.includes(item.id) ? 'boderL' : ''">
          <div class="clickCheckBox" @click="clickCheckBox(item)"></div>
          <div class="check-group">
            <Checkbox v-model="item._checked" :disabled="item._disabled" @on-change="handleCheckItem($event, item)"></Checkbox>
          </div>
          <div class="posterEdit">
            <img src="@static/images/product/Twriting.png" alt="" v-if="item.copywriting" @click="openWriting(item)">
            <img src="@static/images/product/openImg.png" alt="" @click="$refs['img' + index][0].click()">
            <img src="@static/images/product/edit.png" alt="" @click.stop="control = !control" v-if="$units.pointAction('content_2_1_1') && $units.pointAction('content_2_1_3')">
            <div class="controls" v-if="control" @click.stop="control = true">
              <span @click="toTop(item)" v-if="$units.pointAction('content_2_1_1') && index">置顶</span>
              <span @click="$refs.posterModal.open(item)" v-if="$units.pointAction('content_2_1_1')">编辑</span>
              <span @click="deletePost(item)" v-if="$units.pointAction('content_2_1_3')">删除</span>
            </div>
          </div>
          <div class="posterContent">
            <span>来源：{{ item.sourceName }}</span>
            <span>内部阅读数：{{ item.readTimes }}</span>
            <span>分享数：{{ item.shareTimes }}</span>
            <span>创建时间：{{ item.createTime }}</span>
          </div>
        </div>
        <div class="posterTitle">{{ item.title }}</div>
      </div>
    </div>
    <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
      style="text-align: center" />

    <!-- 复制文案 -->
    <Modal v-model="visibleWriting" :mask-closable="false" :footer-hide="true" class="my-modal">
      <div class="writingTitle">{{ writingData.title }}</div>
      <div class="writingContent" v-if="writingData.copywriting">{{ writingData.copywriting }}</div>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="copywrite(writingData.copywriting)">复制文案</Button>
        <Button type="text" @click="visibleWriting = false">返回</Button>
      </div>
    </Modal>

    <!-- 新增分类 -->
    <Modal v-model="visible" :title="title" :mask-closable="false" :footer-hide="true" class="my-modal">
      <Form ref="form" :model="formData" :label-width="80" class="formGauge">
        <FormItem label="分类名称" prop="name" :rules="$units.formRule.required('请输入分类名称')">
          <Input v-model="formData.name" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submitAddType" v-preventReClick="1000">确定</Button>
      </div>
    </Modal>

    <!-- 管理分类 -->
    <Modal v-model="visible2" title="管理分类" :mask-closable="false" :footer-hide="true" class="my-modal manageModal">
      <span class="tips">按住排序按钮拖拽可对分类进行排序</span>
      <div class="table-box template-table" style="margin: 20px 0;">
        <loading :isShow="listLoading" />
        <table width="100%" v-if="posterList && posterList.length > 0">
          <thead>
            <tr>
              <th>栏目名称</th>
              <th style="width: 160px">操作</th>
            </tr>
          </thead>
          <draggable v-model="posterList" tag="tbody" @update="update" filter=".undraggable">
            <tr v-for="item in posterList" :key="item.id" :class="{ activeTr: item.active }">
              <td class="undraggable">{{ item.name + '(' + item.nums + ')' }}</td>
              <td style="width: 160px">
                <div class="action">
                  <div class="actionBlank undraggable"></div>
                  <div class="actionBtns">
                    <img class="table-btn undraggable" src="@static/images/product/edit_2.png" @click="addType(item)">
                    <img class="table-btn undraggable" src="@static/images/product/delete.png" @click="deleteTpye(item)">
                    <img class="table-btn" src="@static/images/product/drage.png" alt="">
                  </div>
                </div>
              </td>
            </tr>
          </draggable>
        </table>
        <no-data v-if="!posterList.length"></no-data>
      </div>
    </Modal>

    <!-- 移动分类 -->
    <Modal v-model="visibleChange" title="移动分类" :mask-closable="false" :footer-hide="true" class="my-modal top">
      <div class="changeTips">
        将 <span style="color:#236DFF;">{{ totalNum }}</span> 张海报移动到分类：
      </div>
      <Form ref="formData" :model="data" :label-width="80" class="formGauge">
        <FormItem label="分类" prop="columnId" :rules="$units.formRule.required('请选择分类')">
          <Select v-model="data.columnId" :transfer="true" clearable>
            <Option :value="items.id" :key="items.id" v-for="items in posterList">{{ items.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visibleChange = false">取消</Button>
        <Button type="primary" @click="changeType" v-preventReClick="1000">确定</Button>
      </div>
    </Modal>

    <posterModal ref="posterModal" @getPoster="getPoster"></posterModal>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import draggable from "vuedraggable";
import { pageTool } from "@/api/mixins";
import posterModal from './components/posterModal'
export default {
  mixins: [pageTool],
  components: {
    draggable,
    selectTree,
    posterModal
  },
  data() {
    return {
      title: '新增分类',
      undraggable: true,
      searchParams: {
        source: '',
      },
      data: {},
      activeTab: '',
      formData: {},
      pageNo: 1,
      pageSize: 12,
      totalNum: 0,
      productListArr: [],
      checkAllGroup: [],
      posterList: [],
      posterArr: [],
      control: false,
      visible: false,
      visible2: false,
      visibleChange: false,
      visibleWriting: false,
      isOnePage: false,
      isAll: false,
      allId: [],
      writingData: {},
      checkItemsList:[]
    }
  },
  activated() {
    this.getPoster();
  },
  created() {
    this.getProductList()
  },
  methods: {
    // 搜索
    searchAjax() {
      this.pageNo = 1;
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isOnePage = false;
      this.cancleSelete()
      this.getPoster()
      this.getAllPosterId()
    },
    reset(){
      this.pageNo = 1;
      this.activeTab = 0;
      this.searchParams.date = [];
      this.resetSearch();
      this.getPosterArr();
    },
    clickCheckBox(item){
      this.control = false
      if(this.checkAllGroup.includes(item.id)){
        this.checkAllGroup.splice(item, 1);
        this.totalNum-=1
      }else{
        this.checkAllGroup.push(item.id)
        this.totalNum+=1
      }
    },
    getList() {
      this.listLoading = true;
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        this.searchParams.beginCreateTime = this.searchParams.date[0]
        this.searchParams.endCreateTime = this.searchParams.date[1]
      }
      this.$http({
        url: '/buz/cmsPoster/read/list',
        type: 'POST',
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.searchParams
        }
      })
        .then(res => {
          this.checkItemsList.forEach(item1=>{
            res.data.map(item2=>{
              if(item2.id == item1.id) {
                item2._checked = true;
              }
            })
          })
          // 统计当前页选中的个数
          let checkPageLeng = res.data.filter(item=>item._checked).length;
          if(checkPageLeng == res.data.length){
            this.isOnePage = true;
          }

          this.tableData = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    toTop(val) {
      this.$http({
        url: '/buz/cmsColumn/article/top',
        type: "POST",
        data: {
          id: val.id,
          isTop: true
        }
      }).then(res => {
        this.$notice.success('置顶成功');
        this.getPoster()
        this.cancleSelete()
      })
    },
    deletePost(val) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        this.$http({
          url: '/buz/cmsPoster/del',
          type: "GET",
          data: {
            id: val.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getPoster()
        })
      })
    },
    // 文案复制
    copywrite(value) {
      let oInput = document.createElement("input");
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$Message.success("复制成功");
    },
    // 打开复制文本
    openWriting(item) {
      this.visibleWriting = true
      this.writingData = item
      console.log(this.writingData);
    },
    // 删除多个海报
    batchDelete() {
      if (!this.checkItemsList.length && !this.isAll) {
        this.$notice.msg('至少选择一张海报')
        return 
      }
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: '/buz/cmsPoster/batchDel',
          type: "POST",
          data: {
            ids: this.isAll? this.allId : this.checkItemsList.map(item=>item.id),
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getPoster()
          this.cancleSelete()
          this.searchAjax()
        })
      })

    },
    // 切换分类确认按钮
    changeType() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          if (!this.checkItemsList.length&&!this.isAll) {
            this.$notice.msg('至少选择一张海报')
            return
          }
          this.$http({
            url: '/buz/cmsColumn/batch/moveArticle',
            type: "POST",
            data: {
              ids: this.isAll? this.allId : this.checkItemsList.map(item=>item.id),
              type: 2,
              ...this.data
            }
          }).then(res => {
            this.getPoster()
            this.visibleChange = false
            this.cancleSelete();
            this.searchAjax()
          })
        }
      })
    },
    // 打开切换分类弹窗
    openVisibleChange() {
      this.visibleChange = true
      this.data = {}
      this.$refs.formData && this.$refs.formData.resetFields();
      this.getPosterList()
    },
    // 刷新分类列表
    getPoster() {
      this.getPosterArr()
      this.getList()
    },
    // 清空勾选数据
    cancleSelete() {
      this.isAll = false
      this.isOnePage = false
      this.totalNum = 0
      this.checkAllGroup = []
    },
    // 全选
    handleCheckAll() {
      this.isOnePage = this.isAll;
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = this.isAll;
        item._checked = this.isAll;
      });
      this.tableData = tableData;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      if(this.isAll) {
        this.getAllPosterId();
      }
    },
    // 点击选中当前图片
    selectedItem(item) {
      this.$set(item, '_checked', item._checked == undefined ? true : !item._checked);
      this.handleCheckItem(item._checked, item);
    },
    // 选中当前勾选框
    handleCheckItem(value, item) { 
      if(value) {
        this.checkAllGroup.push(item.id);
        // 把当前已选中的数据存放到数组中
        this.checkItemsList.push(item);
        // 获取当前页选中的个数
        let len = this.tableData.filter(item=>item._checked).length;
        if(len == this.tableData.length){
          this.isOnePage = true;
        }        
      }else{
        // 当前页选中数据不等于分页条页，去掉当前页选中
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
        if(this.checkAllGroup.length != this.tableData.length){
          this.isOnePage = false;
        }
        // 从已选中删除掉当前去掉选中的数据
        this.checkItemsList = this.checkItemsList.filter(data => data.id != item.id);
      }
    },
    // 当前页海报
    handleCheck() {
      this.isAll = false;
      if(this.isOnePage) {
        const arr = this.tableData.filter(item => item.id);
        this.checkAllGroup = arr.map(item => item.id);
        this.tableData.forEach(item => {
          item._checked = true;
        });
        // 获取当前页可导入id集合，并从已选数组中删除掉
        let tableListIds =  this.tableData.filter(item=>item.id);
        // 获取所有已选的id
        let checkedIds = this.checkItemsList.map(item=>item.id);
        tableListIds.map(item=>{
          if(!checkedIds.includes(item.id)){
            this.checkItemsList.push(item);
          }
        })
      }else{
        this.checkAllGroup = [];
        this.tableData.forEach(item => {
          item._checked = false;
        });
        // 获取当前页id集合，并从已选数组中删除掉
        let tableListIds =  this.tableData.map(item=>item.id);
        this.checkItemsList = this.checkItemsList.filter(item=>!tableListIds.includes(item.id));
      }
    },

    changeCheckBox() {
      console.log(this.checkAllGroup);
      this.totalNum = this.checkAllGroup.length
      if (this.checkAllGroup.length != this.tableData.length && this.isOnePage) {
        this.isOnePage = false
      } else if (this.checkAllGroup.length != this.allId.length && this.isAll) {
        this.isAll = false
      }
    },
    // 排序
    update() {
      let list = [];
      list = JSON.parse(JSON.stringify(this.posterList));
      this.$http({
        url: '/buz/cmsColumn/dragSort',
        type: "POST",
        data: list,
      }).then(res => {
        this.getPosterList()
        this.getPosterArr()
      })
    },
    // 删除分类
    deleteTpye(item) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: '/buz/cmsColumn/del',
          type: "GET",
          data: {
            id: item.id
          },
        }).then(res => {
          this.getPosterList()
          this.getPosterArr()
          this.$notice.success('删除成功');
        })
      })
    },
    //打开管理分类弹窗
    manageType() {
      this.visible2 = true;
      this.getPosterList()
    },
    // 提交新增分类
    submitAddType() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let url
          if (this.formData.id) {
            url = '/buz/cmsColumn/edit'
          } else {
            url = '/buz/cmsColumn/add'
          }
          this.$http({
            url: url,
            type: "POST",
            data: {
              type: 2,
              ...this.formData
            },
          }).then(res => {
            this.$notice.success('操作成功');
            this.visible = false
            this.getPosterList()
            this.getPosterArr()
            this.getList()
          })
        }
      });
    },
    // 从公共素材库导入
    toPublicMaterialsPage() {
      this.$router.push({
        path: '/contentManagement/publicMaterialLibrary',
        query: {
          typeIndex: 1 ,
          time:JSON.stringify(new Date())
        }
      })
    },
    //打开新增分类弹窗
    addType(item) {
      this.formData ={}
      this.visible = true;
      // 打开弹窗时清除校验
      this.$refs.form.fields.forEach((v, i) => {
        v.validateDisabled = true;
        v.validateState = "";
        v.validateMessage = "";
      });
      if (item) {
        this.title = '编辑分类'
        this.formData = item
      } else {
        this.title = '新增分类'
      }
    },
    pageChange(pageNo) {
      if (!this.isAll) {
        this.isOnePage = false;
        this.checkAllGroup = [];
      }
      this.pageNo = pageNo;
      this.getList(pageNo);
    },
    changeTab(val) {
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isOnePage = false;
      this.totalNum = 0
      this.pageNo = 1
      if (!val) {
        this.searchParams.columnId = ''
      } else {
        this.searchParams.columnId = val
      }
      this.getList()
    },
    // 海报id
    getAllPosterId() {
      this.$http({
        url: "/buz/cmsPoster/queryList",
        type: "post",
        data: this.searchParams,
      }).then((res) => {
        this.allId = res.data
        if (this.isAll) {
          this.checkAllGroup = res.data;
          this.totalNum = this.checkAllGroup.length
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    // tab海报分类
    getPosterArr() {
      this.$http({
        url: "/buz/cmsPoster/column/list",
        type: "post",
        data: {
          ...this.searchParams
        },
      }).then((res) => {
        this.posterArr = res.data;
      })
    },
    // 内容管理拖拽排序海报分类
    getPosterList() {
      this.$http({
        url: "/buz/cmsColumn/read/list",
        type: "post",
        data: {
          type: 2
        },
      }).then((res) => {
        this.posterList = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    // 产品
    getProductList() {
      this.$http({
        url: "/buz/productBase/read/short/list",
        type: "post",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        this.productListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding-left: 20px !important;
}
/deep/ .ivu-modal-footer{
  border-radius: 6px;
}
/deep/ .pswp__button--arrow--left {
  left: 10% !important;
}
.tips{
      width: 100%;
      height: 80px;
      padding: 20px;
      background: #FFF8EF;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img{
        width: 40px;
        margin-right: 10px;
      }
      .tipsContent{
        .tips1{
          display: block;
          color: #6A5041;
          font-size: 13px;
          font-weight: 800;
          font-family: PingFang SC;
          line-height: 18px;
          margin-bottom: 5px;
        }
        .tips2{
          color: #76665D;
          font-size: 12px;
          line-height: 17px;
          .iconzhuyi1{
            font-size: 12px;
            color: #FF0000;
            margin-right: 2px;
          }
          img{
            margin: 0;
            width: 14px;
            vertical-align: text-bottom;
          }
        }
        img{
          width: 12px;
        }
      }
    }
.manageModal{
  /deep/ .ivu-modal-body{
    padding-bottom:30px;
  }
}
.buttonBox {
  margin-bottom: 10px;
}

.contentList {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;

  .posterList {
    margin-right: 30px;
    margin-bottom: 35px;

    .poster {
      width: 240px;
      height: 426px;
      position: relative;
      .clickCheckBox{
        position: absolute;
        top: 0;
        left: 0;
        width: 240px;
        height: 426px;
      }
      &:hover .posterContent {
        display: block;
      }

      .posterContent {
        display: none;
        position: absolute;
        width: 240px;
        height: 85px;
        border-radius: 0px 0px 10px 10px;
        bottom: 0;
        right: 0;
        background: #000;
        opacity: 0.8;
        padding-top: 8px;
        padding-left: 12px;

        span {
          display: block;
          color: #fff;
          font-size: 12px;
          line-height: 18px;
          font-family: PingFang SC;
        }

      }

      &:hover .posterEdit {
        display: block;
      }

      .posterEdit {
        display: none;
        position: absolute;
        top: 10px;
        right: 0;
        text-align: right;
        cursor: pointer;

        .controls {
          margin: 10px;
          background: #fff;
          width: 84px;
          height: 100%;
          border-radius: 4px;

          span {
            display: block;
            height: 30px;
            line-height: 30px;
            text-align: center;
          }
        }

        img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
        object-position: top;
      }
      /deep/.ivu-checkbox-checked .ivu-checkbox-inner {
        background: #000;
        opacity: .6;
        border-color: none;
      }
    }
  }

  .posterTitle {
    max-width: 240px;
    margin-top: 12px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .check-group {
    position: absolute;
    top: 10px;
    left: 10px;
  }
}

.tabBtn {
  position: relative;

  /deep/.ivu-tabs-nav {
    max-width: 80%;
    overflow-x: auto;
  }
  /deep/ .ivu-tabs-tab-active {
    font-weight: bold;
  }

  .btn {
    position: absolute;
    top: 10px;
    right: 0;

    span {
      line-height: 18px;
      color: #236DFF;
      margin-right: 30px;
      cursor: pointer;
    }
  }

}

.my-modal {
  .tips {
    display: block;
    margin-top: 20px;
    margin-bottom: 15px;
    color: #727C8E;
  }
}

table {
  word-wrap: bread-word;
  word-break: break-all;
  table-layout: fixed;
  border-collapse: collapse;

  thead {
    background: #f8f8f9;
  }

  th {
    border: 1px solid #eee;
    padding: 10px 10px;
  }

  tr {
    &.activeTr {
      background: #409eff;
      color: #fff;

      .details {
        >div {
          color: #fff;
        }
      }
    }
  }

  td {
    text-align: center;
    border: 1px solid #eee;
    padding: 0 10px;
    height: 38px;
  }
}

.action {
  width: 100%;
  height: 100%;
  position: relative;

  .actionBlank {
    width: 100%;
    height: 100%;
  }

  .actionBtns {
    position: absolute;
    top: 25%;
  }
}

.table-btn {

  margin: 0;
  padding: 0 15px;

  &:not(:last-child) {
    border-right: 1px solid #CED1D5;
  }
}

.batchOperation {
  margin-bottom: 20px;
  height: 50px;
  background: #F5F7F9;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .checkBoxList {
    margin-left: 20px;
    display: flex;

    .checkBox {
      margin-right: 30px;
      color: #3C464F;
      font-size: 13px;
    }

    .quantity {
      color: #727C8E;
      font-size: 12px;
    }

    .btn {
      font-size: 12px;
      color: #236DFF;
      cursor: pointer;
      margin-left: 18px;
    }
  }
}

.changeTips {
  margin-top: 20px;
}

.writingTitle {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  color: #3C464F;
}

.writingContent {
  font-size: 13px;
  line-height: 20px;
  color: #515C6F;
  margin-top: 20px;
}

.boderL {
  border: 2px solid #236DFF;
}</style>